export enum PermissionType {
    LIDS = 1,
    MY_ROULLETES,
    REDEMPTION,
    BUSINESS_CUPON,
    BUSINESS_MANAGMENT
};